import { render, staticRenderFns } from "./InquirySearch.vue?vue&type=template&id=c03ef3bc&"
import script from "./InquirySearch.vue?vue&type=script&lang=js&"
export * from "./InquirySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSharedPaginations: require('/app/components/ui/shared/Paginations.vue').default})
